/**
 * Puane B2B lot motoru
 * Lot kodunu secili varyanttan / satir basligindan dinamik okur.
 */
(function () {
  'use strict';

  function calculateLotSize(value) {
    return window.PuaneLotRules?.count(value) ?? null;
  }
  function findLotCode(text) {
    return window.PuaneLotRules?.extract(text) || '';
  }
  var metafields = {};
  function loadMetafields() {
    document.querySelectorAll('script[type="application/json"][data-puane-variants]').forEach(function (script) {
      try {
        JSON.parse(script.textContent).forEach(function (variant) {
          if (variant.id && Number(variant.lot_quantity) > 0) metafields[variant.id] = Number(variant.lot_quantity);
        });
      } catch (error) {}
    });
  }
  function resolve(input) {
    var row = input.closest('quick-add-bulk, tr, [data-variant-id], .quick-order-list__row, .quick-order-list__item');
    var variantId = row && (row.getAttribute('data-variant-id') || row.getAttribute('data-index') || input.dataset.quantityVariantId);
    if (variantId && metafields[variantId]) return { size: metafields[variantId], certain: true };
    var explicitCode = input.dataset.puaneLotCode || (row && row.dataset.puaneLotCode) || '';
    if (explicitCode) {
      var explicitSize = calculateLotSize(explicitCode);
      return { size: explicitSize, certain: explicitSize !== null, code: explicitCode };
    }
    var title = input.getAttribute('data-variant-title') || (row && (row.getAttribute('data-variant-title') || row.getAttribute('data-title')));
    var code = findLotCode(title) || findLotCode(row ? row.textContent : '');
    var size = calculateLotSize(code);
    return { size: size, certain: size !== null, code: code };
  }
  function showError(input) {
    var row = input.closest('quick-add-bulk, tr, [data-variant-id], .quick-order-list__row');
    if (!row || row.querySelector('.puane-lot-error')) return;
    var message = document.createElement('div');
    message.className = 'puane-lot-error';
    message.textContent = 'Lot adedi belirlenemedi. Lutfen yetkiliyle iletisime gecin.';
    message.style.cssText = 'color:#c0392b;font-size:.8em;padding:4px 8px;background:#fde8e8;border-radius:4px;margin-top:4px;';
    (input.closest('td, .quick-order-list__quantity') || row).appendChild(message);
  }
  function clearError(input) {
    var row = input.closest('tr, [data-variant-id], .quick-order-list__row');
    var message = row && row.querySelector('.puane-lot-error');
    if (message) message.remove();
  }
  function syncSeriesDisplay(input, lotSize) {
    var display = input.closest('.quantity') && input.closest('.quantity').querySelector('[data-puane-series-count]');
    if (!display) return;
    var quantity = Math.max(0, Number(input.value) || 0);
    display.textContent = String(lotSize > 0 ? Math.round(quantity / lotSize) : quantity);
  }
  function apply() {
    loadMetafields();
    document.querySelectorAll('quick-order-list input[type="number"], .quick-order-list input[type="number"], quick-add-bulk input[type="number"]').forEach(function (input) {
      var result = resolve(input);
      if (!result.certain) { input.dataset.lotSize = '0'; input.dataset.lotCertain = '0'; syncSeriesDisplay(input, 0); return; }
      input.dataset.lotSize = String(result.size);
      input.dataset.lotCertain = '1';
      input.step = String(result.size);
      input.min = '0';
      if (!input.value || Number(input.value) < 0) input.value = '0';
      syncSeriesDisplay(input, result.size);
    });
  }
  function buttons(event) {
    var button = event.target.closest('button[name="plus"], button[name="minus"]');
    if (!button) return;
    var container = button.closest('.quantity, quick-order-list-input, .quick-order-list__quantity');
    var input = container && container.querySelector('input[type="number"]');
    if (!input) return;
    var lot = Number(input.dataset.lotSize || 0);
    if (input.dataset.lotCertain !== '1' || !lot) {
      event.preventDefault(); event.stopImmediatePropagation(); showError(input); return;
    }
    if (lot <= 1) return;
    event.preventDefault(); event.stopImmediatePropagation();
    var current = Number(input.value) || 0;
    input.value = String(button.name === 'plus' ? (current === 0 ? lot : current + lot) : (current <= lot ? 0 : current - lot));
    syncSeriesDisplay(input, lot);
    clearError(input);
    input.dispatchEvent(new Event('input', {bubbles:true}));
    input.dispatchEvent(new Event('change', {bubbles:true}));
  }
  function inputChange(event) {
    var input = event.target;
    if (!input || input.type !== 'number' || !input.closest('quick-order-list, .quick-order-list, quick-add-bulk')) return;
    var lot = Number(input.dataset.lotSize || 0);
    if (input.dataset.lotCertain !== '1' || !lot) { if (Number(input.value) > 0) input.value = '0'; return; }
    if (lot > 1 && Number(input.value) > 0) input.value = String(Math.round(Number(input.value) / lot) * lot);
    syncSeriesDisplay(input, lot);
    clearError(input);
  }
  function init() {
    apply();
    document.addEventListener('click', buttons, true);
    document.addEventListener('change', inputChange, false);
    document.addEventListener('quick-order-list:update', function () { setTimeout(apply, 200); });
    new MutationObserver(function (changes) { if (changes.some(function (change) { return change.addedNodes.length; })) setTimeout(apply, 150); }).observe(document.body, {childList:true, subtree:true});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  window.PuaneLot = {
    calculateLotSize: calculateLotSize,
    getLotSizeFromTitle: findLotCode,
    getDisplay: function (value) { return window.PuaneLotRules?.display(value) || String(value || ''); }
  };
}());
